import PropTypes from 'prop-types';
import React, { useEffect, useEffectEvent } from 'react';
import { ChatAPI } from '@guuru/chat-web';
import OpenDialogButton from './OpenDialogButton';

const EmojiPicker = React.lazy(() => import('./EmojiPicker'));

const ChatEmojiButton = function ({ onEmojiSelect, onToggle, opened }) {
  const locale = ChatAPI.storeRetrieveLocale();
  const handleEscape = useEffectEvent(() => {
    if (opened) onToggle();
  });

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') handleEscape();
    };
    if (opened) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [opened]);

  return (
    <React.Suspense fallback={<OpenDialogButton loading />}>
      <div className="chat-emoji-input">
        <OpenDialogButton isActive={opened} onClick={onToggle} />
        {opened && (
          <EmojiPicker
            dynamicWidth
            locale={locale}
            theme="light"
            previewPosition="none"
            skinTonePosition="none"
            onEmojiSelect={(emoji) => onEmojiSelect(emoji.native)}
            onClickOutside={onToggle}
          />
        )}
      </div>
    </React.Suspense>
  );
};

ChatEmojiButton.propTypes = {
  onEmojiSelect: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired,
};

export default ChatEmojiButton;
